import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Area, ComposedChart } from 'recharts';
import ExpandableChart from './ExpandableChart';

const DecompositionChart = ({ housingData, unemploymentData }) => {
  const formatHousingData = housingData?.filter(item => item.date && item.mean).map(item => ({
    date: item.date,
    value: parseFloat(item.mean) || 0,
    lower: (parseFloat(item.mean) || 0) - 10000,
    upper: (parseFloat(item.mean) || 0) + 10000
  })) || [];

  const formatUnempData = unemploymentData?.filter(item => item.date && item.mean).map(item => ({
    date: item.date,
    value: parseFloat(item.mean) || 0,
    volatility: 0.2
  })) || [];

  const unempImages = [
    'a5fd525a-b096-434b-839c-66ff81c07544.png',
    '3abf9891-58e1-4333-9659-dcbf5b6ca15c.png'
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ExpandableChart title="Housing Price Forecast">
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={formatHousingData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 12 }} />
              <YAxis 
                tick={{ fontSize: 12 }}
                label={{
                  value: 'Housing Price ($)',
                  angle: -90,
                  position: 'insideLeft',
                  style: { textAnchor: 'middle' }
                }}
              />
              <Tooltip />
              <Legend />
              <Area
                dataKey="upper"
                fill="#2563eb"
                stroke="none"
                fillOpacity={0.1}
                name="Upper Bound"
              />
              <Area
                dataKey="lower"
                fill="#2563eb"
                stroke="none"
                fillOpacity={0.1}
                name="Lower Bound"
              />
              <Line
                type="monotone"
                dataKey="value"
                stroke="#2563eb"
                name="Forecast"
                dot={true}
              />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </ExpandableChart>

      <ExpandableChart 
        title="Unemployment Rate Forecast"
        images={unempImages}
      >
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={formatUnempData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 12 }} />
              <YAxis 
                tick={{ fontSize: 12 }}
                label={{
                  value: 'Unemployment Rate (%)',
                  angle: -90,
                  position: 'insideLeft',
                  style: { textAnchor: 'middle' }
                }}
              />
              <Tooltip />
              <Legend />
              <Area
                dataKey="volatility"
                fill="#dc2626"
                stroke="none"
                fillOpacity={0.1}
                name="Volatility Range"
              />
              <Line
                type="monotone"
                dataKey="value"
                stroke="#dc2626"
                name="Forecast"
                dot={true}
              />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </ExpandableChart>
    </div>
  );
};

export default DecompositionChart;